var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPpimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 37,
    viewBox: "0 0 52 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 9.54165C15.3333 13.2235 12.3485 16.2083 8.66665 16.2083C4.98477 16.2083 2 13.2235 2 9.54165C2 5.85977 4.98477 2.875 8.66665 2.875C12.3485 2.875 15.3333 5.85977 15.3333 9.54165ZM15.3333 9.54165H49.9999M36.6666 28.2083C36.6666 31.8901 39.6514 34.8749 43.3332 34.8749C47.0151 34.8749 49.9999 31.8901 49.9999 28.2083C49.9999 24.5264 47.0151 21.5416 43.3332 21.5416C39.6514 21.5416 36.6666 24.5264 36.6666 28.2083ZM36.6666 28.2083H2",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpimage);
export default __webpack_public_path__ + "static/media/ppimage.faf1f708c3817d7b6d821201cd21457b.svg";
export { ForwardRef as ReactComponent };